import {emojiRegex} from './emojiRegex';

/**
 * @name stringContainsEmojis
 */
export const stringContainsEmojis = (string: string): boolean =>
  emojiRegex.test(string);
